import React, { useEffect, useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import _, { isNil, isEmpty } from 'lodash'
import moment from 'moment'
import {
  Div, H4, P, InputWithLabel, Input, Loading,
} from 'konsys-ui'
import {
  DatePicker, Row, Col, message,
} from 'antd'
import numeral from 'numeral'
import { theme } from '../../../styles/_variables'
import detailType, { RemarksDetailModeHandler, isLatedMoreThan15days } from '../util-functions'
import {
  detailMode, status, dealType, dealTypeText,
} from '../constants'
import {
  GET_JOB, GET_REMAINING_FUEL_BY_TRUCK, RECOMMEND_AVAILABLE_ORDER, RECOMMEND_FUEL_AMOUNT, SHIPPING_ORDER,
} from '../../../constants/graphql/query'
import { MYINFO } from '../../../constants/graph/query'
import { CREATE_SHIPPING_OREDER, UPDATE_SHIPPING_OREDER } from '../../../constants/graphql/mutation'
import { ActionBar } from '../../../components/shipping-order-components'
import history from '../../../history'
import {
  FlatbedInfo, OtherTypeInfo, AssignDriver, AssignFillingOrder, ExpenseSection,
} from './extension-components'
import PERMISSION from '../../../constants/permissions'
import { colorSelector, textStatusSelector } from '../list/table'
import { DriverShippingDetail } from './driverPage'
import MobileList from '../list/mobile'
import ROLE from '../../../constants/role'

const dealTypeSelector = (e) => {
  switch (e) {
    case dealType.PERTRIP:
      return dealTypeText.PERTRIP
    case dealType.PERWEIGHT:
      return dealTypeText.PERWEIGHT
    default:
      return 'ไม่ระบุ'
  }
}

const { color } = theme

const Index = ({ props }) => {
  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)
  if (myInfoLoading || _.isEmpty(myInfo)) return <Loading center='true' />
  if (!_.isEmpty(props?.match?.params?.shippingVolume) && !_.isEmpty(props?.match?.params?.shippingNumber)
    && _.includes([ROLE.DRIVER.id, ROLE.CUSTOMER.id, ROLE.CARGO_OFFICER.id], myInfo.myInfo.Roles[0].id)) return <MobileList shippingVolume={props?.match?.params?.shippingVolume} shippingNumber={props?.match?.params?.shippingNumber} />
  if (myInfo.myInfo.Roles[0].id === ROLE.DRIVER.id) return <DriverShippingDetail props={props} />
  return <ShippingDetail props={props} />
}

const ShippingDetail = ({ props }) => {
  // if (_.isUndefined(props.match.params.id)) {
  //   history.push('/shipping-order')
  //   return null
  // }

  // const accessFuel
  // useEffect(() => {
  //   { accessFuel } = props.history.location.state
  // }, [props.history.location.state.accessFuel])
  const onlyStartEndDestination = _.isUndefined(props.history.location.state) ? false : props.history.location.state.onlyStartEndDestination
  const accessFuel = _.isUndefined(props.history.location.state) ? false : props.history.location.state.accessFuel
  const accessSpecialFuel = _.isUndefined(props.history.location.state) ? false : props.history.location.state.accessSpecialFuel
  const accessDelivered = _.isUndefined(props.history.location.state) ? false : props.history.location.state.accessDelivered
  const accessDriver = _.isUndefined(props.history.location.state) ? false : props.history.location.state.accessDriver
  const refetchRemainingFuel = _.isUndefined(props.history.location.state) ? false : props.history.location.state.refetchRemainingFuel

  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isUpdateMode = props.match.params.mode.toUpperCase() === detailMode.EDIT
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState(isAddMode ? { containerOption: 'NONE' } : {})
  const [clientInfo, setClientInfo] = useState({})
  const [footerChanged, setFooterChanged] = useState(false)
  const [fuelInputAmount, setFuelInputAmount] = useState(0)

  // const recommendAvailableOrder = useQuery(RECOMMEND_AVAILABLE_ORDER, {
  //   variables: {
  //     startDestinationId: mutationVariables.startDestination,
  //     endDestinationId: mutationVariables.endDestination,
  //   },
  //   skip: _.isUndefined(mutationVariables.startDestination) || _.isUndefined(mutationVariables.endDestination),
  //   onCompleted: (res) => {
  //     setMutationVariables({ ...mutationVariables, availableOrder: res.recommendAvailableOrder })
  //   },
  // })

  const onChangeHandler = (id, value) => {
    const floatParams = [
      'weightDifferenceLimit',
      'feeTotal',
      'startWeight',
      'endWeight',
      'totalWeight',
      'feeRate',
      'expense',
      'tariff',
      'roundWeight',
      'price',
      'compensation',
    ]
    const intParams = ['startDestination', 'endDestination']

    if (_.isArray(id)) {
      setMutationVariables({
        ...mutationVariables,
        [id[0].key]: id[0].value,
        [id[1].key]: id[1].value,
      })
    } else {
      const parseValue = _.includes(floatParams, id)
        ? _.isNaN(parseFloat(value)) ? undefined : parseFloat(value)
        : _.includes(intParams, id)
          ? _.isNaN(parseInt(value, 10)) ? undefined : parseInt(value, 10)
          : value
      setMutationVariables({
        ...mutationVariables,
        [id]: parseValue,
      })
    }
  }

  const setClientHandler = (obj) => {
    setClientInfo({
      ...clientInfo,
      ...obj,
    })
  }

  return (
    <Div display='flex' flexDirection='column'>
      {
        isAddMode
          ? <AddModeRender
              id={props.match.params.id}
              mutationVariables={mutationVariables}
              setMutationVariables={setMutationVariables}
              onChangeHandler={onChangeHandler}
              setClientHandler={setClientHandler}
              clientInfo={clientInfo}
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
            />
          : <NotAddModeRender
              id={props.match.params.id}
              isAddMode={isAddMode}
              shippingVolume={props.match.params.shippingVolume}
              shippingNumber={props.match.params.shippingNumber}
              isViewMode={isViewMode}
              isUpdateMode={isUpdateMode}
              mutationVariables={mutationVariables}
              setMutationVariables={setMutationVariables}
              onChangeHandler={onChangeHandler}
              setClientHandler={setClientHandler}
              clientInfo={clientInfo}
              accessDelivered={accessDelivered}
              accessFuel={accessFuel}
              accessDriver={accessDriver}
              accessSpecialFuel={accessSpecialFuel}
              setFooterChanged={setFooterChanged}
              props={props}
              footerChanged={footerChanged}
              fuelInputAmount={fuelInputAmount}
              setFuelInputAmount={setFuelInputAmount}
              refetchRemainingFuel={refetchRemainingFuel}
              onlyStartEndDestination={onlyStartEndDestination}
            />
      }
    </Div>
  )
}

const AddModeRender = ({
  id,
  mutationVariables,
  setMutationVariables,
  onChangeHandler,
  setClientHandler,
  clientInfo,
  isAddMode,
  isViewMode,
  props,
}) => {
  const [fetchRecommendFuelAmount, { data: recommendFuelAmountData }] = useLazyQuery(RECOMMEND_FUEL_AMOUNT)
  const { data: jobData, error, loading } = useQuery(GET_JOB, {
    variables: { id },
    skip: _.isNil(id),
    fetchPolicy: 'network-only',
  })
  const recommendFuelAmount = recommendFuelAmountData?.recommendFuelAmount?.recommendFuelAmount

  useEffect(() => {
    if (jobData) {
      const {
        startDestinationLocation,
        endDestinationLocation,
        availableOrder: jobAvailableOrder,
        shippings,
      } = jobData.JobInfo

      setMutationVariables({
        ...mutationVariables,
        availableOrder: jobAvailableOrder || '-',
        shippings: jobAvailableOrder ? shippings.length : '-',
        remainingOrder: jobAvailableOrder ? jobAvailableOrder - shippings.length : '-',
        customerId: jobData.JobInfo.customerId,
        jobId: jobData.JobInfo.id,
        startDestination: startDestinationLocation.id,
        endDestination: endDestinationLocation.id,
      })

      // Set startDestinationText if undefined
      if (_.isUndefined(clientInfo.startDestinationText) && startDestinationLocation) {
        setClientHandler({ startDestinationText: startDestinationLocation.branch })
      }
      // Set endDestinationText if undefined
      if (_.isUndefined(clientInfo.endDestinationText) && endDestinationLocation) {
        setClientHandler({ endDestinationText: endDestinationLocation.branch })
      }
      // Fetch recommended fuel amount
      if (startDestinationLocation?.id && endDestinationLocation?.id && jobData?.JobInfo?.Truck?.TruckBrand?.id) {
        fetchRecommendFuelAmount({
          variables: {
            input: {
              startDestinationId: startDestinationLocation?.id,
              endDestinationId: endDestinationLocation?.id,
              truckBrandId: jobData?.JobInfo?.Truck?.TruckBrand?.id,
            },
          },
        })
      }
    }
  }, [jobData])

  if (loading) return <Loading center='true' />
  if (error) return <P>เกิดข้อผิดพลาด</P>
  return (
    <DetailContainer
      mode={{ isAddMode, isViewMode }}
      props={props}
      onChangeHandler={onChangeHandler}
      client={{ clientInfo, setClientHandler }}
      mutationVariables={mutationVariables}
      setMutationVariables={setMutationVariables}
      data={jobData}
      recommendFuelAmount={recommendFuelAmount}
    />
  )
}

const NotAddModeRender = ({
  id,
  isAddMode,
  isViewMode,
  isUpdateMode,
  shippingVolume,
  shippingNumber,
  mutationVariables,
  setMutationVariables,
  onChangeHandler: parentOnChangeHandler,
  setClientHandler,
  clientInfo,
  accessDelivered,
  accessFuel,
  accessDriver,
  accessSpecialFuel,
  setFooterChanged,
  props,
  footerChanged,
  fuelInputAmount,
  setFuelInputAmount,
  refetchRemainingFuel,
  onlyStartEndDestination,
}) => {
  const [hasFuel, setHasFuel] = useState(false)
  const [fetchRemainingFuelAmount, { data: remainingFuelAmountData }] = useLazyQuery(GET_REMAINING_FUEL_BY_TRUCK, {
    fetchPolicy: 'network-only',
  })
  const queryRemainingFuelList = remainingFuelAmountData?.GetRemainingFuelByTruck?.remainingFuelList

  const [fetchRecommendFuelAmount, { data: recommendFuelAmountData }] = useLazyQuery(RECOMMEND_FUEL_AMOUNT)

  const {
   data, error, loading, refetch,
  } = useQuery(SHIPPING_ORDER, {
    variables: {
      id,
      shippingVolume,
      shippingNumber,
    },
    fetchPolicy: 'cache-and-network',
    onCompleted: (shippingData) => {
      if (_.isUndefined(mutationVariables.customerId)) parentOnChangeHandler('customerId', shippingData.ShippingorderInfo.customerId)
      if (_.isUndefined(mutationVariables.jobId)) parentOnChangeHandler('jobId', shippingData.ShippingorderInfo.jobId)
      if (_.isUndefined(mutationVariables.truckFiles)) setMutationVariables({ ...mutationVariables, truckFiles: shippingData.ShippingorderInfo.truckImages || [] })
      if (_.isUndefined(clientInfo.startDestinationText)) setClientHandler({ startDestinationText: shippingData.ShippingorderInfo.startDestinationLocation.branch })
      if (_.isUndefined(clientInfo.endDestinationText)) setClientHandler({ endDestinationText: shippingData.ShippingorderInfo.endDestinationLocation.branch })
      if (_.isUndefined(mutationVariables.availableOrder)) {
        setMutationVariables({
          ...mutationVariables, availableOrder: shippingData.ShippingorderInfo.Job.availableOrder || [], shippings: shippingData.ShippingorderInfo.Job.shippings.length, remainingOrder: shippingData.ShippingorderInfo.Job.availableOrder - shippingData.ShippingorderInfo.Job.shippings.length,
        })
      }
      if (!_.isNull(shippingData?.ShippingorderInfo?.startDestinationLocation) && _.isUndefined(mutationVariables.startDestination)) {
        parentOnChangeHandler('startDestination', shippingData?.ShippingorderInfo?.startDestinationLocation?.id)
      }
      if (!_.isNull(shippingData?.ShippingorderInfo?.endDestinationLocation) && _.isUndefined(mutationVariables.endDestination)) {
        parentOnChangeHandler('endDestination', shippingData?.ShippingorderInfo?.endDestinationLocation?.id)
      }

      if (!_.isNil(shippingData?.ShippingorderInfo?.FuelOrder?.id) || !_.isEmpty(data?.ShippingorderInfo?.remainingFuelShippingOrder)) {
        setHasFuel(true)
      }
      if (shippingData?.ShippingorderInfo?.Truck?.id && (isEmpty(shippingData?.ShippingorderInfo?.remainingFuelShippingOrder) || accessFuel || refetchRemainingFuel)) {
        fetchRemainingFuelAmount({
          variables: {
            id: shippingData?.ShippingorderInfo?.Truck?.id,
          },
        })
      }
      if (shippingData?.ShippingorderInfo?.startDestinationLocation?.id && shippingData?.ShippingorderInfo?.endDestinationLocation?.id && shippingData?.ShippingorderInfo?.Truck?.TruckBrand?.id) {
        fetchRecommendFuelAmount({
          variables: {
            input: {
              startDestinationId: shippingData?.ShippingorderInfo?.startDestinationLocation?.id,
              endDestinationId: shippingData?.ShippingorderInfo?.endDestinationLocation?.id,
              truckBrandId: shippingData?.ShippingorderInfo?.Truck?.TruckBrand?.id,
            },
          },
        })
      }
    },
  })

  const recommendFuelAmount = !_.isNil(data?.ShippingorderInfo?.recommendAtStamp)
    ? data.ShippingorderInfo.recommendAtStamp
    : recommendFuelAmountData?.recommendFuelAmount?.recommendFuelAmount

  const JobInfo = data?.ShippingorderInfo?.Job

  useEffect(() => {
    if (!accessFuel && !_.isNil(data?.ShippingorderInfo?.totalAmountAtStamp)) {
      setFuelInputAmount(data.ShippingorderInfo.totalAmountAtStamp)
    } else if (accessFuel && !_.isNil(recommendFuelAmount)) {
      setFuelInputAmount(recommendFuelAmount)
    }
  }, [recommendFuelAmount, data?.ShippingorderInfo?.totalAmountAtStamp, accessFuel])

  // Handle refetchRemainingFuel flag
  useEffect(() => {
    if (refetchRemainingFuel && data?.ShippingorderInfo?.Truck?.id) {
      fetchRemainingFuelAmount({
        variables: {
          id: data.ShippingorderInfo.Truck.id,
        },
      })
    }
  }, [refetchRemainingFuel, data?.ShippingorderInfo?.Truck?.id])

  if (loading && _.isEmpty(data)) return <Loading center='true' />
  if (_.isEmpty(data)) return <Loading center='true' />
  if (error) return <P>เกิดข้อผิดพลาด</P>

  // Calculate remaining fuel list and related values
  const remainingFuelList = isEmpty(data?.ShippingorderInfo?.remainingFuelShippingOrder)
  ? hasFuel
    ? []
    : queryRemainingFuelList
  : data?.ShippingorderInfo?.remainingFuelShippingOrder
  const isUsingRemainingFuelShippingOrder = !isEmpty(data?.ShippingorderInfo?.remainingFuelShippingOrder)

  const remainingFuelRef = remainingFuelList?.map((fuel) => {
    const fuelShippingVolume = fuel.remainingFuel?.fuelOrder?.shippingVolume || fuel.fuelOrder?.shippingVolume
    const fuelShippingNumber = fuel.remainingFuel?.fuelOrder?.shippingNumber || fuel.fuelOrder?.shippingNumber

    let fuelAmount
    if (isUsingRemainingFuelShippingOrder) {
      // Use reservedAmount directly when using remainingFuelShippingOrder
      fuelAmount = fuel.reservedAmount || 0
    } else {
      // Use remainingAmount - usedAmount for query data
      const remainingAmount = fuel.remainingAmount || 0
      const usedAmount = fuel.usedAmount || 0
      fuelAmount = remainingAmount - usedAmount
    }

    return `${fuelShippingVolume}/${fuelShippingNumber} (${fuelAmount})`
  }).join(', ')

  const calculatedRemainingFuelAmount = remainingFuelList?.reduce((acc, current) => {
    let fuelAmount
    if (isUsingRemainingFuelShippingOrder) {
      // Use reservedAmount directly when using remainingFuelShippingOrder
      fuelAmount = current.reservedAmount || 0
    } else {
      // Use remainingAmount - usedAmount for query data
      const remainingAmount = current.remainingAmount || 0
      const usedAmount = current.usedAmount || 0
      fuelAmount = remainingAmount - usedAmount
    }

    return acc + fuelAmount
  }, 0)

  if (
    isUpdateMode
    && (!_.includes([status.ASSIGNED, status.WAITING, status.EXPIRED, status.CANCELLED, status.PICKEDUP, status.DELIVERED], data.ShippingorderInfo.status) || isLatedMoreThan15days(data.ShippingorderInfo.status, data.ShippingorderInfo.assignDate))
    && !accessDelivered
    && !accessFuel
    && !accessDriver
    && !accessSpecialFuel
  ) {
    message.error('ไม่สามารถแก้ไขได้เนื่องจากสถานะการขนส่ง')
    history.push(`/shipping-order/view/${id}`)
  }

  const onChangeHandler = (fieldId, value) => {
    const floatParams = ['compensation', 'weightDifferenceLimit', 'feeTotal', 'startWeight', 'endWeight', 'totalWeight', 'feeRate', 'expense', 'tariff', 'roundWeight', 'price']
    const intParams = ['startDestination', 'endDestination']

    if (fieldId === 'images' || fieldId === 'remark' || fieldId === 'truckFiles') setFooterChanged(true)
    if (_.isArray(fieldId)) {
      setMutationVariables({
        ...mutationVariables,
        [fieldId[0].key]: fieldId[0].value,
        [fieldId[1].key]: fieldId[1].value,
      })
    } else {
      const parseValue = _.includes(floatParams, fieldId)
        ? _.isNaN(parseFloat(value)) ? undefined : parseFloat(value)
        : _.includes(intParams, fieldId)
          ? _.isNaN(parseInt(value, 10)) ? undefined : parseInt(value, 10)
          : value
      setMutationVariables({
        assignDate: data.ShippingorderInfo.assignDate,
        compensation: data.ShippingorderInfo.compensation,
        endDestination: data.ShippingorderInfo.endDestinationLocation.id,
        shippingNumber: data.ShippingorderInfo.shippingNumber,
        shippingVolume: data.ShippingorderInfo.shippingVolume,
        startDestination: data.ShippingorderInfo.startDestinationLocation.id,
        weightDifferenceLimit: data.ShippingorderInfo.weightDifferenceLimit,
        feeRate: data.ShippingorderInfo.feeRate,
        ...mutationVariables,
        [fieldId]: parseValue,
      })
    }
  }


  return (
    <DetailContainer
      onlyStartEndDestination={onlyStartEndDestination}
      accessDriver={accessDriver}
      accessFuel={accessFuel}
      accessSpecialFuel={accessSpecialFuel}
      accessDelivered={accessDelivered}
      refetch={refetch}
      mode={{ isAddMode, isViewMode, isUpdateMode }}
      props={props}
      onChangeHandler={onChangeHandler}
      client={{ clientInfo, setClientHandler }}
      mutationVariables={mutationVariables}
      footerChanged={footerChanged}
      setMutationVariables={setMutationVariables}
      hasFuel={hasFuel}
      recommendFuelAmount={recommendFuelAmount}
      remainingFuelAmount={!accessFuel ? data?.ShippingorderInfo?.remainingFuelAtStamp : calculatedRemainingFuelAmount}
      remainingFuelRef={remainingFuelRef}
      missingFuelAmount={
        !_.isNil(recommendFuelAmount) && !_.isNil(!accessFuel ? data?.ShippingorderInfo?.remainingFuelAtStamp : calculatedRemainingFuelAmount)
          ? Math.max((recommendFuelAmount || 0) - ((!accessFuel ? data?.ShippingorderInfo?.remainingFuelAtStamp : calculatedRemainingFuelAmount) || 0), 0)
          : null
      }
      fuelInputAmount={fuelInputAmount}
      setFuelInputAmount={setFuelInputAmount}
      data={{
        ShippingorderInfo: {
          ...data.ShippingorderInfo,
          JobInfo: {
            jobCode: JobInfo.jobCode,
            unit: JobInfo.unit,
            createdAt: data.ShippingorderInfo.createdAt,
            volumn: JobInfo.volumn,
            number: JobInfo.number,
            assignDate: data.ShippingorderInfo.assignDate,
            Customer: {
              companyId: data.ShippingorderInfo.Customer.companyId,
              companyName: data.ShippingorderInfo.Customer.companyName,
            },
          },
        },
        JobInfo: {
          availableOrder: JobInfo.availableOrder,
          shippings: JobInfo.shippings,
          jobCode: JobInfo.jobCode,
          unit: JobInfo.unit,
          createdAt: data.ShippingorderInfo.createdAt,
          volumn: JobInfo.volumn,
          number: JobInfo.number,
          assignDate: data.ShippingorderInfo.assignDate,
          Customer: {
            companyId: data.ShippingorderInfo.Customer.companyId,
            companyName: data.ShippingorderInfo.Customer.companyName,
          },
        },
      }}
    />
  )
}

const DetailContainer = ({
  mode: { isAddMode, isViewMode, isUpdateMode },
  data, props, onChangeHandler, client: { clientInfo, setClientHandler },
  mutationVariables, refetch, accessFuel, accessDelivered, accessDriver, footerChanged, accessSpecialFuel,
  setMutationVariables, recommendFuelAmount, remainingFuelAmount, remainingFuelRef, hasFuel, fuelInputAmount, setFuelInputAmount, onlyStartEndDestination,
}) => {
  const [driver, setDriver] = useState({})
  const [fuelType, setFuelType] = useState()
  const [creatingFuel, setCreatingFuel] = useState(false)
  const isExpiredStatus = data?.ShippingorderInfo?.status === status.EXPIRED

  return (
    <Div>
      {/* ================== Section 1 ================== */}
      <Div
        display='flex'
        flexDirection='row'
        alignItems='center'
        justifyContent={!isAddMode ? 'space-between' : 'flex-end'}
        padding='32px 0 40px 0'
        style={{ borderBottom: `1px solid ${color.paleGrey}` }}
      >
        {
          !isAddMode && <Div display='flex' flexDirection='column'>
            <H4 bold>Ref ID - {data.ShippingorderInfo.shippingCode}</H4>
            <P bold>วันที่สร้าง - {moment(data.ShippingorderInfo.JobInfo.createdAt).format('DD MMMM YYYY')}</P>
            <Div margin='8px 0 0'>
              <P bold>สถานะการขนส่ง:&nbsp;</P><H4 bold color={colorSelector(data.ShippingorderInfo.status)}>{textStatusSelector(data.ShippingorderInfo.status)}</H4>
            </Div>
          </Div>
        }
        <Div display='flex'>
          <InputWithLabel
            margin='0 8px'
            width='120px'
            title={{ text: 'เล่มที่ *' }}
            input={{
              disabled: isViewMode || !_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER) || accessFuel || accessDelivered || accessDriver || [status.CANCELLED, status.EXPIRED].includes(data?.ShippingorderInfo?.status),
              onChange: e => onChangeHandler('shippingVolume', e.target.value),
              defaultValue: _.isUndefined(data.ShippingorderInfo) ? null : data.ShippingorderInfo.shippingVolume,
            }}
          />
          <InputWithLabel
            margin='0 8px'
            width='120px'
            title={{ text: 'เลขที่ใบสั่งจ่าย *' }}
            input={{
              disabled: isViewMode || !_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER) || accessFuel || accessDelivered || accessDriver || [status.CANCELLED, status.EXPIRED].includes(data?.ShippingorderInfo?.status),
              onChange: e => onChangeHandler('shippingNumber', e.target.value),
              defaultValue: _.isUndefined(data.ShippingorderInfo) ? null : data.ShippingorderInfo.shippingNumber,
            }}
          />
          <Div margin='0 8px' >
            <P margin='0 0 16px' display='block'>วันที่ครบกำหนด *</P>
            <DatePicker
              disabled={isViewMode || !_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER) || accessFuel || accessDelivered || accessDriver || [status.CANCELLED, status.EXPIRED].includes(data?.ShippingorderInfo?.status) || onlyStartEndDestination}
              disabledDate={current => current && current < moment().subtract(1, 'd').endOf('day')}
              defaultValue={_.isUndefined(data.ShippingorderInfo) ? undefined : moment(data.ShippingorderInfo.JobInfo.assignDate, 'YYYY/MM/DD')}
              format={'YYYY/MM/DD'}
              onChange={(e) => {
                onChangeHandler('assignDate', !_.isNull(e) ? moment(e).format('YYYY-MM-DD') : undefined)
              }}
            />
          </Div>
        </Div>
      </Div>
      {/* ================== Section 2 ================== */}
      <Row align='flex-start' type='flex' gutter={12} style={{ borderBottom: `1px solid ${color.paleGrey}`, padding: '32px 0 40px' }}>
        <Col span={8}>
          <Row style={{ marginBottom: 8 }}>
            <Col span={6}>
              <P>สัญญางาน</P>
            </Col>
            <Col span={16}>
              <P>Ref ID {isAddMode ? data.JobInfo.jobCode : data.ShippingorderInfo.JobInfo.jobCode}</P>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <P>เลขที่ {isAddMode ? data.JobInfo.number : data.ShippingorderInfo.JobInfo.number}</P>
            </Col>
          </Row>
        </Col>
        <Col span={8}>
          <Row style={{ marginBottom: 8 }}>
            <Col span={24}>
              <P>ผู้จ้าง</P>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <P>{isAddMode ? data.JobInfo.Customer.companyName : data.ShippingorderInfo.Customer.companyName}</P>
            </Col>
            <Col span={5} offset={1}>
              <P>{isAddMode ? data.JobInfo.Customer.branch : data.ShippingorderInfo.Customer.branch}</P>
            </Col>
          </Row>
        </Col>
        <Col span={4}>
          <Row style={{ marginBottom: 8 }}>
            <Col span={24}>
              <P>ประเภทผู้จ้าง</P>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <P>{isAddMode ? data.JobInfo.Customer.TypeOfCharge.name : data.ShippingorderInfo.Customer.TypeOfCharge.name}</P>
            </Col>
          </Row>
        </Col>
        <Col span={4}>
          <Row style={{ marginBottom: 8 }}>
            <Col span={24}>
              <P>ประเภทสัญญางาน</P>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <P>{dealTypeSelector(isAddMode ? data.JobInfo.dealType : data.ShippingorderInfo.Job.dealType)}</P>
            </Col>
          </Row>
        </Col>
      </Row>
      {
      isAddMode
        ? detailType(props.match.params, onChangeHandler, { clientInfo, setClientHandler }, { driver, setDriver }, { fuelType, setFuelType }, accessFuel, accessDelivered, accessDriver, mutationVariables, data.JobInfo)
        : detailType(props.match.params, onChangeHandler, { clientInfo, setClientHandler }, { driver, setDriver }, { fuelType, setFuelType }, accessFuel, accessDelivered, accessDriver, mutationVariables, data.ShippingorderInfo.Job, data.ShippingorderInfo, onlyStartEndDestination) // argument mode
      }
      {/* ================== Assign Driver section ================== */}
      <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
        {
          isAddMode
            ? <AssignDriver
              // onChange={(key, value) => onChangeHandler(key, value)}
              props={{ text: 'จ่ายงานให้พนักงานขับรถ', icon: 'far fa-plus', fullWidth: true }}
              initialData={data.ShippingorderInfo}
              driver={driver}
              setDriver={driverObj => setDriver(driverObj)}
              setFuelType={fuelTypeValue => setFuelType(fuelTypeValue)}
              disabled={true}
              dealType={isAddMode ? data.JobInfo.dealType : data.ShippingorderInfo.Job.dealType}
              shippingOrderId={props.match.params.id || data?.ShippingorderInfo?.id}
              refetch={refetch}
              isUpdateMode={isUpdateMode}
              mutationVariables={mutationVariables}
              setMutationVariables={setMutationVariables}
            />
            : <AssignDriver
              disabled={!accessDriver || isViewMode || !_.includes(window.perms, PERMISSION.ASSIGN_SHIPPING_ORDER) || !_.includes([status.ASSIGNED, status.WAITING], data.ShippingorderInfo.status)}
              initialData={data.ShippingorderInfo}
              // onChange={(key, value) => onChangeHandler(key, value)}
              props={{ text: 'จ่ายงานให้พนักงานขับรถ', icon: 'far fa-plus', fullWidth: true }}
              driver={driver}
              setDriver={driverObj => setDriver(driverObj)}
              setFuelType={fuelTypeValue => setFuelType(fuelTypeValue)}
              dealType={isAddMode ? data.JobInfo.dealType : data.ShippingorderInfo.Job.dealType}
              shippingOrderId={props.match.params.id || data?.ShippingorderInfo?.id}
              refetch={refetch}
              isUpdateMode={isUpdateMode}
              accessDriver={accessDriver}
              mutationVariables={mutationVariables}
              footerChanged={footerChanged}
              setMutationVariables={setMutationVariables}
            />
        }
      </Div>
      {/* ================== Assign Filling section ================== */}
      <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
        {
          (hasFuel || accessFuel)
          && (
            <div>
              <P display='block' margin='0 0 8px 0'>
                ปริมาณน้ำมันที่ระบบแนะนำ: <span className='font-bold'>{!_.isNil(recommendFuelAmount) ? numeral(recommendFuelAmount).format('0.0') : '-'} ลิตร</span>
              </P>
              <P display='block' margin='0 0 8px 0'>
                {!accessFuel ? 'ปริมาณน้ำมันที่เหลือและนำมาใช้' : 'ปริมาณน้ำมันที่เหลือ'}:&nbsp;
                <span className='font-bold'>{!_.isNil(remainingFuelAmount) ? numeral(remainingFuelAmount).format('0.0') : '-'} ลิตร</span>
                <span className='ml-4'>ref: {remainingFuelRef || '-'}</span>
              </P>
              <Div display='flex' alignItems='center' margin='0 0 16px 0'>
                <P margin='0 8px 0 0'>
                  น้ำมันที่คาดว่าจะใช้:
                </P>
                <Input
                  value={fuelInputAmount}
                  onChange={e => setFuelInputAmount(parseFloat(e.target.value) || 0)}
                  disabled={
                    !accessFuel
                    || (
                      !_.isNil(recommendFuelAmount)
                      && !_.includes(window.perms, PERMISSION.CREATE_FUEL_ORDER_OVER_LIMIT)
                    )
                  }
                  type='number'
                  step='0.1'
                  width='120px'
                  margin='0 8px 0 0'
                />
                <span>ลิตร</span>
              </Div>
            </div>
          )
        }
        { (!isNil(data?.ShippingorderInfo?.FuelOrder?.id) || isEmpty(data?.ShippingorderInfo?.remainingFuelShippingOrder))
        && <AssignFillingOrder
          disabled={
            !accessFuel
            || isViewMode
            || !_.includes(window.perms, PERMISSION.CREATE_FUEL)
            || !_.includes([status.ASSIGNED, status.DELIVERED, status.BILLED], data.ShippingorderInfo.status)
            || (fuelInputAmount <= remainingFuelAmount)
          }
          creatingFuel={creatingFuel}
          setCreatingFuel={setCreatingFuel}
          initialData={data.ShippingorderInfo}
          onChange={(key, value) => onChangeHandler(key, value)}
          props={{ text: 'สร้างใบเบิกน้ำมัน', icon: 'far fa-plus', fullWidth: true }}
          fuelType={fuelType}
          mutationVariables={mutationVariables}
          shippingOrderId={props.match.params.id || data?.ShippingorderInfo?.id}
          refetch={refetch}
          accessFuel={accessFuel}
          footerChanged={footerChanged}
          isSpecial={false}
          missingFuelAmount={Math.max(fuelInputAmount - (remainingFuelAmount || 0), 0)}
          requestedFuelAmount={fuelInputAmount}
          isViewMode={isViewMode}
          accessSpecialFuel={accessSpecialFuel}
        />
        }
      </Div>
      {/* ================== Special Assign Filling section ================== */}
      <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
        <AssignFillingOrder
          disabled={!accessSpecialFuel || !_.includes(window.perms, PERMISSION.CREATE_FUEL)}
          creatingFuel={creatingFuel}
          setCreatingFuel={setCreatingFuel}
          initialData={data.ShippingorderInfo}
          onChange={(key, value) => onChangeHandler(key, value)}
          props={{ text: 'สร้างใบเบิกน้ำมันพิเศษ', icon: 'far fa-plus', fullWidth: true }}
          fuelType={fuelType}
          mutationVariables={mutationVariables}
          shippingOrderId={props.match.params.id || data?.ShippingorderInfo?.id}
          refetch={refetch}
          accessFuel={accessFuel}
          footerChanged={footerChanged}
          isSpecial
          isViewMode={isViewMode}
          accessSpecialFuel={accessSpecialFuel}
        />
      </Div>
      {/* ================== Record section ================== */}
      {
        !isAddMode && _.includes([status.ASSIGNED, status.PICKEDUP, status.DELIVERED, status.BILLED, status.EXPIRED, status.BILLED], data.ShippingorderInfo.status)
          ? data.ShippingorderInfo.Job.dealType === 'PERTRIP'
            ? <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
              <FlatbedInfo // แบบเที่ยว
                accessDelivered={accessDelivered}
                onChangeHandler={(key, value) => onChangeHandler(key, value)}
                initialData={data.ShippingorderInfo}
                mutationVariables={mutationVariables}
                disabled={
                  !accessDelivered
                  || isViewMode
                  || !_.includes(window.perms, PERMISSION.RECORD_DELIVERY_SHIPPING_ORDER)
                  || (!_.includes([status.ASSIGNED, status.PICKEDUP, status.DELIVERED, status.EXPIRED, status.BILLED], data.ShippingorderInfo.status) || isLatedMoreThan15days(data.ShippingorderInfo.status, data.ShippingorderInfo.assignDate))
                }
                shippingOrderId={props.match.params.id || data?.ShippingorderInfo?.id}
                refetch={refetch}
                props={
                  {
                    text: _.includes([status.ASSIGNED, status.PICKEDUP, status.EXPIRED], data.ShippingorderInfo.status)
                      ? 'บันทึกการขนส่ง'
                      : 'แก้ไขการขนส่ง',
                    icon: 'far fa-plus',
                    fullWidth: true,
                  }}
                footerChanged={footerChanged}
              />
            </Div>
            : <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
              <OtherTypeInfo // แบบน้ำหนัก
                accessDelivered={accessDelivered}
                onChangeHandler={(key, value) => onChangeHandler(key, value)}
                initialData={data.ShippingorderInfo}
                mutationVariables={mutationVariables}
                disabled={
                  !accessDelivered
                  || isViewMode
                  || !_.includes(window.perms, PERMISSION.RECORD_DELIVERY_SHIPPING_ORDER)
                  || (!_.includes([status.ASSIGNED, status.PICKEDUP, status.DELIVERED, status.EXPIRED, status.BILLED], data.ShippingorderInfo.status) || isLatedMoreThan15days(data.ShippingorderInfo.status, data.ShippingorderInfo.assignDate))
                }
                shippingOrderId={props.match.params.id || data?.ShippingorderInfo?.id}
                refetch={refetch}
                props={
                  {
                    text: _.includes([status.ASSIGNED, status.PICKEDUP, status.EXPIRED], data.ShippingorderInfo.status)
                      ? 'บันทึกการขนส่ง'
                      : 'แก้ไขการขนส่ง',
                    icon: 'far fa-plus',
                    fullWidth: true,
                  }}
                footerChanged={footerChanged}
              />
            </Div>
          : null
      }
      {/* ================== Remarks section ================== */}
      {
        isAddMode
          ? <Div>
            <ExpenseSection
              onChangeHandler={onChangeHandler}
              initialData={data.ShippingorderInfo}
              mutationVariables={mutationVariables}
              disabled={accessFuel || isViewMode || data?.ShippingorderInfo?.status === status.CANCELLED || isExpiredStatus}
            />
            {
              RemarksDetailModeHandler(props.match.params, onChangeHandler, { clientInfo, setClientHandler }, accessFuel, accessDelivered, accessDriver)
            }
          </Div>
          : <Div>
            <ExpenseSection
              onChangeHandler={onChangeHandler}
              initialData={data.ShippingorderInfo}
              mutationVariables={mutationVariables}
              disabled={accessFuel || isViewMode || data?.ShippingorderInfo?.status === status.CANCELLED || onlyStartEndDestination || isExpiredStatus}
            />
            {
              RemarksDetailModeHandler(props.match.params, onChangeHandler, { clientInfo, setClientHandler }, accessFuel, accessDelivered, accessDriver, data.ShippingorderInfo, onlyStartEndDestination) // argument mode
            }
          </Div>
      }
      {/* ================== Footer section ================== */}
      {
        !accessDelivered && !accessDriver && !accessFuel && !accessSpecialFuel
          ? !isViewMode
            ? <Mutation
              mutation={isAddMode ? CREATE_SHIPPING_OREDER : UPDATE_SHIPPING_OREDER}
            >{(doAction, { loading: mutationLoading }) => (
              <ActionBar
                refetch={refetch}
                loading={mutationLoading}
                isAddMode={isAddMode}
                isViewMode={isViewMode}
                doAction={doAction}
                clientInfo={clientInfo}
                mutationVariables={mutationVariables}
                props={props}
                ShippingorderInfoStatus={data.ShippingorderInfo && data.ShippingorderInfo.status}
                disabledPrint={!_.includes([status.ASSIGNED, status.WAITING], data.ShippingorderInfo && data.ShippingorderInfo.status) || _.includes(window.perms, PERMISSION.EXPORT_SHIPPING_ORDER)}
                ShippingorderInfo={data.ShippingorderInfo}
                unit={data.JobInfo.unit}
                jobInfo={data.JobInfo}
                creatingFuel={creatingFuel}
              />
            )}
            </Mutation>
            : <ActionBar
              // loading={loading}
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
              disabledPrint={!_.includes([status.ASSIGNED, status.WAITING], data.ShippingorderInfo && data.ShippingorderInfo.status)}
              ShippingorderInfo={data.ShippingorderInfo}
              creatingFuel={creatingFuel}
              refetch={refetch}
            />
          : null
      }
    </Div>
  )
}

export default Index
export { Index }
